// Fetch wrapper with the CMS auth headers all editor API calls need.
export default function apiFetch(path, token, options = {}) {
    return fetch(path, {
        ...options,
        headers: {
            'Authorization': `Bearer ${token}`,
            'X-EDITOR': 'nanoms',
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
}
